import * as React from 'react'
import { MdSpinner, MdTabs } from '../widgets'
import { translate } from 'react-translate'
import { toLower, sortBy } from 'lodash'

const tdHeaderStyle = {
  textAlign: 'center',
  padding: "10px",
  paddingLeft: "10px",
  paddingRight: "0px"
}
const tdFirstElementStyle = {
  color: '#aaa',
  fontWeight: 'bold' as 'bold',
  paddingLeft: "19px",
  paddingRight: "10px"

}
const tdElementStyle = {
  paddingLeft: "10px",
  paddingRight: "0px"
}
const tdH3Style = {
  textAlign: 'center'
}
const defaultTableStyle = {
  width: '100%'
}

class FeesTable extends React.Component<any, any> {

  constructor (props: any) {
    super(props)
    const ewarrantFeeType = ['Certification', 'Cancellation']
    this.state = {
      ewarrantTypes: ewarrantFeeType
    }
    this.changeFee = this.changeFee.bind(this)
  }

  public changeFee(index, tier, metalId, prop, contractId, newValue) {
    this.props.updateFees(index, tier, metalId, prop, contractId, newValue)
  }

  private getSortedEvwProducts(fees) {
    return _.map(fees, (f: any) => {
      const contract = window['md3'].contract.filter({
        id: f.contractId
      })

      if (contract[0]) {
        const product = window['md3'].product.filter({
          id: String(contract[0].productId),
          metalId: contract[0].metalId
        })

        const metal = window['md3'].metal.filter({
          id: String(contract[0].metalId)
        })

        const hub = window['md3'].hub.filter({
          id: String(contract[0].hubId)
        })

        return {
          contractId: contract[0].id,
          product: product[0].name,
          metal: metal[0].name,
          hub: hub[0].name
        }
      }
    })
  }

  private ewarrantFeeSpinners(feeRateTiers, feeGroupIndex, t) {
    const contracts = _.compact(this.getSortedEvwProducts(feeRateTiers))

    const label = [
      <div>
        <h3 style={tdH3Style}>{t('EWARRANT_HEADER')}</h3>
      </div>
    ]
    const contractRender = _.map(sortBy(contracts, ['hub', 'metal', 'product']), (ewarrant: any, key) => {
      let feeForContract: EwarrantFee[] = _.filter(feeRateTiers, function(f: any){
        return f.contractId && Number(f.contractId) === Number(ewarrant.contractId)
      })
      const fee: any = feeForContract[0] ? feeForContract[0] : {
        feeRate: 0,
        tier: 1,
        metalId: 0,
        contractId: ewarrant.contractId
      }

      let text = fee.placeHolder && !this.props.readOnly ? ' - (Sponsor\'s default)' : ''

      return <div key={key} style={{marginTop: '1px'}}>
        <MdSpinner
          readOnly={this.props.readOnly}
          minimumDisplayValue={0}
          adjustmentAmount={1}
          title={
            <div>
              <span className={toLower(ewarrant.metal) + '-legend'}></span>
              <span>{ewarrant.hub} - {ewarrant.product}<span style={{fontSize: '8px'}}>{text}</span></span>
            </div>
          }
          amount={fee.feeRate || 0}
          divisor={1}
          valueChangeFn={this.changeFee.bind(null, feeGroupIndex, fee.tier, 0, 'feeRate', fee.contractId)}
        />
      </div>
    })

    return label.concat(contractRender)
  }

  private setActiveEwarrantFeeType(feeType) {
    this.props.changeEwarrantFeeType(feeType)
  }

  private ewarrantFeeTypeTab(t) {
    return <div style={{marginTop: '10px'}} key={1}>
        <MdTabs tabs={
        _.map(this.state.ewarrantTypes, (feeType, key) => {
          return {
            content: feeType as string,
            handleClick: () => this.setActiveEwarrantFeeType(feeType)
          }
        })
      } activeTab={this.props.activeEwarrantFeeType} tabStyle={{width: '100%'}} />
    </div>
  }

  public render () {
    const feeRateTiers = this.props.fees
    const feeGroupIndex = this.props.feeGroupIndex
    let t = this.props.t

    return (
    <div style={this.props.tableStyle}>
      {(feeRateTiers.length === 1) ? (
        <div style={{marginTop: '20px'}}>
          <MdSpinner
            readOnly={this.props.readOnly}
            maximumDisplayValue={100}
            minimumDisplayValue={0}
            adjustmentAmount={0.001}
            title={t('SPINNER_TITLE')}
            amount={feeRateTiers[0].feeRate || 0}
            divisor={100}
            valueChangeFn={this.changeFee.bind(null, feeGroupIndex, feeRateTiers[0].tier, feeRateTiers[0].metalId, 'feeRate', 0)}
          />
        </div>
      ) : (null) }
      {(feeRateTiers.length > 1) ? (
          this.props.ewarrantFees ?
          [this.ewarrantFeeTypeTab(t), this.ewarrantFeeSpinners(feeRateTiers, feeGroupIndex, t)]
          :
          <table style={defaultTableStyle}>
            <thead>
              <tr>
                <td style={tdHeaderStyle}><h3 style={tdH3Style}>{t('TIER_HEADER')}</h3></td>
                <td style={tdHeaderStyle}><h3 style={tdH3Style}>{t('BOUND_HEADER')}</h3></td>
                <td style={tdHeaderStyle}><h3 style={tdH3Style}>{t('RATE_HEADER')}</h3></td>
              </tr>
            </thead>
            <tbody>
              {
                feeRateTiers.map((clientFee, key) => {
                  return (
                    <tr key={key}>
                      <td style={tdFirstElementStyle}> {clientFee.tier} </td>
                      <td style={tdElementStyle}>
                        <MdSpinner
                          readOnly={this.props.readOnly}
                          title=''
                          amount={clientFee.tierValue || 0}
                          minimumDisplayValue={0}
                          adjustmentAmount={1}
                          divisor='1'
                          valueChangeFn={this.changeFee.bind(null, feeGroupIndex, clientFee.tier, clientFee.metalId, 'tierValue', 0)}
                          key={key}
                        />
                      </td>
                      <td style={tdElementStyle}>
                        <MdSpinner
                          readOnly={this.props.readOnly}
                          adjustmentAmount={0.001}
                          title=''
                          amount={clientFee.feeRate || 0}
                          maximumDisplayValue={100}
                          minimumDisplayValue={0}
                          divisor={100}
                          valueChangeFn={this.changeFee.bind(null, feeGroupIndex, clientFee.tier, clientFee.metalId, 'feeRate', 0)}
                          key={key}
                        />
                      </td>
                    </tr>
                  )
                })}
            </tbody>
          </table>
      ) : (null) }
    </div>)
  }
}
export default translate('FeesTable')(FeesTable)



// WEBPACK FOOTER //
// ./react/components/presentations/FeesTable.tsx